import request from "@/utils/request";

export async function getProfileData() {
  const result = await request(`${REACT_APP_API_BASE_URL_NEW}/api/identity-service/user-management/my-profile`, {});

  return result?.data;
}

export async function updateProfileData({
  firstName,
  lastName,
  phoneNumber,
  phoneExtension,
  businessPhoneNumber,
  businessPhoneNumberExtension,
  state,
  stateShortName,
  city,
  addressLine1,
  addressLine2,
  zipCode,
}) {
  const data = {
    firstName,
    lastName,
    phoneNumber,
    phoneExtension,
    businessPhoneNumber,
    businessPhoneNumberExtension,
    state,
    stateShortName,
    city,
    addressLine1,
    addressLine2,
    zipCode,
  };

  const result = await request(`${REACT_APP_API_BASE_URL_NEW}/api/identity-service/user-management/profile`, {
    method: "PUT",
    data,
  });

  return result?.data;
}

export async function updateProfilePic(params) {
  const result = await request(`${REACT_APP_API_BASE_URL_NEW}/api/identity-service/user-management/profile-photo`, {
    method: "PATCH",
    params,
  });
  return result?.data;
}

export async function changeMyPassword(params) {
  const result = await request(`${REACT_APP_IDENTITY_SERVER_BASE_URL}/api/account/my-profile/change-password`, {
    method: "POST",
    data: params,
  });

  if ("error" in result) {
    throw new Error(result.error);
  }

  return result;
}
